function Agencies(){
    return (
        <div className="text-orange-400 text-center font-extrabold text-4xl">
            <div>Number 1</div>
            <div>Number 2</div>
            <div>Number 3</div>
            <div>Number 4</div>
            <div>Number 5</div>
            <div>Number 6</div>
            <div>Number 7</div>
            <div>Number 8</div>

        </div>
    )

}
export default Agencies;